<template>
  <div id="app">
    <div class="mack" v-if="showMenu"></div>
    <div v-if="showMenu" class="menu_list">
      <ul>
        <li v-for="(item,index) in title"
            :key="index"
            @click="changeIndex1(index,item)">
          <span v-if="item.name">{{item.name}}</span>
          <img :src="item.img" alt="" v-if="item.img">
        </li>
      </ul>
    </div>
    <div class="main_header">
      <div class="bar_menu">
        <div>
          <img src="./assets/img/logo.png" alt="" class="menu_logo">
          <div class="menu1" @click="change1" v-if="showMenu"></div>
          <div class="menu" @click="change" v-else></div>
        </div>
      </div>
      <div class="header_content">
        <div>
          <img src="./assets/img/logo.png" alt="" >
        </div>
        <div class="guide_title">
          <ul>
            <li v-for="(item,index) in title"
                :key="index"
                :class="index==idx?'active':''"
                @click="changeIndex(index,item)">
              {{item.name}}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main_router">
      <router-view/>
      <div class="home_bottom">
        <div class="bottom_guide">
          <ul v-for="(item,index) in list" :key="index">
            <span class="bottom_title" style="cursor: pointer" @click="gotoPath(item)">{{item.title}}</span>
            <li v-for="(tab,i) in item.items" :key="i" @click="goto(item,tab,i)" style="cursor: pointer">
              <span v-if="!tab.phone">{{tab.name}}</span>
              <a :href="tab.phone" v-if="tab.phone" style="color:#fff;text-decoration:none">{{tab.name}}</a>
              <img :src=tab.img alt="" v-if="tab.img">
            </li>
          </ul>
        </div>
        <div class="bottom_detail">
          © 2021 EasyLink Innovation Co., Ltd. 杭州易联创智科技有限公司 <a href="https://beian.miit.gov.cn/">浙ICP备2020031909号-1</a>
        </div>
      </div>
      <div class="home_bottom1">
        <div class="bottom_detail">
          <div>
            © 2021 EasyLink Innovation Co., Ltd. 杭州易联创智科技有限公司 <a href="https://beian.miit.gov.cn/">浙ICP备2020031909号-1</a>
          </div>
          <img src="./assets/img/weixin.png" alt="" @click="showImg" style="cursor: pointer">
        </div>
      </div>
    </div>
    <div class="dialog_experience">
      <el-dialog
        @close="handleClose"
        :close-on-click-modal="false"
        title="立即体验"
        :visible.sync="dialogVisible"
        width="852px">
        <span class="span_content">您可以拨打0571-86653903与我们联系，或将需求发送至邮箱yilian@easylink5g.com，邮件内容参考如下：</span>
        <div class="body_content">
          <div>
            <P>姓名：张三</P>
            <P>手机号：150****9520</P>
            <P>公司：杭州易联创智科技有限公司</P>
            <P>行业：通讯</P>
            <P>需求描述：通过5G消息查询账单、缴费充值、业务办理</P>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleClose">我已了解</el-button>
    </span>
      </el-dialog>
    </div>
    <div class="top_header" v-if="showTop">
      <div @click="changea">
        <img src="./assets/img/tiyan.png" alt="">
        <span>立即体验</span>
      </div>
      <div @click="gotoTop">
        <img src="./assets/img/top.png" alt="">
        <span>返回顶部</span>
      </div>
    </div>
    <img src="./assets/img/erweima.png" alt="" v-if="erweima" @click="erweima=false" class="bottom_erweima_ing">
  </div>
</template>

<script>
  import erweima from "./assets/img/erweima.jpg"
  import logo from "./assets/img/logo.png"
export default {
  data(){
    return{
      dialogVisible:false,
      showTop:false,
      nowIndex: 0,
      lastIndex: 0,
      showMenu:false,
      show:false,
      erweima:false,
      idx:0,
      title: [
        {
          img: logo,
        },
        {
          name: "首页",
          path:"/"
        },
        {
          name: "产品介绍",
          path:"/product"
        },
        {
          name: "解决方案",
          path:"/programme"
        },
        {
          name: "动态资讯",
          path:"/information"
        },
        {
          name: "关于易联",
          path:"/aboutus"
        },
        {
          name: "立即体验",
        }
      ],
      list:[
        {
          title:"产品介绍",
          path:"/product",
          items:[
            {
              name:"六大特点",
              id:"#trait"
            },
            {
              name:"页面介绍",
              id:"#introduce"
            },
          ]
        },
        {
          title:"解决方案",
          path:"/programme",
          items:[
            {
              name:"科技",
              id:"#programme0",
            },
            {
              name:"文旅",
              id:"#programme1",
            },
            {
              name:"能源",
              id:"#programme2",
            },
            {
              name:"政务",
              id:"#programme3",
            },
          ]
        },
        {
          title:"动态资讯",
          path:"/information",
          items:[
            {
              name:"公司动态",
              id:"#message"
            },
            {
              name:"行业资讯",
              id:"#information"
            }
          ]
        },
        {
          title:"关于易联",
          path:"/aboutus",
          items:[
            {
              name:"易联简介",
              id:"#yilian"
            },
            {
              name:"加入我们",
              id:"#joinus"
            },
            {
              name:"联系方式",
              id:"#callwe"
            }
          ]
        },
        {
          title:"联系",
          items:[
            {
              name:"联系电话",
            },
            {
              name:"0571-8665 3903",
              phone:"tel:0571-86653903"
            }
          ]
        },
        {
          title:"微信公众号",
          items:[
            {
              name:"",
              img:erweima
            }
          ]
        }
      ],
      tag:""
    }
  },
  methods: {
    change(){
      this.showMenu = true
    },
    change1(){
      this.showMenu = false
    },
    changea(){
      this.dialogVisible = true
    },
    showImg(){
      this.erweima = !this.erweima
    },
    changeIndex(index,item){
      this.lastIndex = this.nowIndex
      this.nowIndex = index;
      if(index!=6){
        this.idx=index
        this.$router.push(item.path)
        this.showMenu = false
      }else{
        this.dialogVisible = true
        this.showMenu = false
      }
    },
    changeIndex1(index,item){
      this.lastIndex = this.nowIndex
      this.nowIndex = index;
      if(index!=6){
        this.$router.push(item.path)
        this.showMenu = false
      }else{
        this.dialogVisible = true
        this.showMenu = false
      }
    },
    handleClose(){
      this.dialogVisible = false
      this.nowIndex = this.lastIndex
    },
    gotoPath(item,tab){
      this.showMenu = false
      this.$router.push(item.path);
    },
    goto(item,tab,i){
      console.log('item',item);
      console.log('tab',tab);
      this.$router.push(
        {
          path:item.path + `${tab.id}`,
        }
      );
      this.showMenu = false
      // window.location.hash = tab.id
      document.documentElement.scrollTop = document.documentElement.scrollHeight;
      document.body.scrollTop = document.documentElement.scrollHeight;
    },
    gotoTop(){
      window.scrollTo(0,0);
    }
  },
  mounted(){
    let scrollTop = 0
    let width = 0
    let that =this
    window.addEventListener('scroll', function () {
      scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      width = document.documentElement.clientWidth || document.body.clientWidth
      if (scrollTop >0) {
        document.getElementsByClassName("main_header")[0].style.backgroundColor = "rgba(0,0,0,0.85)"
        that.showTop = true;
        that.erweima = false
        that.showMenu = false
      }else{
        if(width>700){
          document.getElementsByClassName("main_header")[0].style.backgroundColor = "transparent"
        }else{
          document.getElementsByClassName("main_header")[0].style.backgroundColor = "#000"
        }
        that.showTop = false
        that.erweima = false
        that.showMenu = false
      }
    })
  }
}
</script>
<style>
  #app {
    top: 0px;
    bottom: 0px;
    background-color:#fff;
    width:100%;
  }
  *{
    margin: 0;
    padding:0
  }
  html,body{
    height:auto;
  }
  .home_bottom>.bottom_guide{
    padding:58px 18.75% 145px;
    display: flex;
    justify-content: space-between;
  }
  .bottom_title{
    position: relative;
    font-size: 16px;
    color: #FFFFFF;
    bottom: 30px;
  }
  .home_bottom>.bottom_guide>ul:nth-child(5)>span{
    color:transparent!important;
  }
  .home_bottom>.bottom_guide>ul:nth-child(5)>li:nth-child(3){
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
  }
  .home_bottom>.bottom_guide>ul{
    display: inline-block;
  }
  .home_bottom>.bottom_guide>ul>li{
    font-size: 14px;
    color: #CCCCCC;
    margin-bottom: 14px;
  }
  ul>li{
    list-style-type: none;
  }
  .bottom_detail{
    padding:0 18.75%;
    text-align: center;
    font-size: 12px;
    color: #CCCCCC;
  }
  .bottom_detail img{
    margin-top: 10px;
    width:20px;
  }
  .bottom_detail a{
    font-size: 12px;
    color: #CCCCCC;
  }
  ::-webkit-scrollbar {
    width:0px;
    background: transparent;
  }
  ::-webkit-scrollbar-track {
    border-radius: 0;
  }
  ::-webkit-scrollbar-thumb {
    transition: all .2s;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }
  .home_bottom{
    position: relative;
    height:400px;
    width: 100%;
    background-image: url("./assets/img/bottom.jpg");
  }
  .main_header{
    z-index:9;
    position: fixed;
    top:0;
    width:100%;
    height:78px;
  }
  .header_content{
    padding:19px 18.75%;
    height:40px;
    line-height:40px;
    display: flex;
    justify-content: space-between;
  }
  li.is_active{
    background-color:#F3831F;
    border-radius: 4px;
  }
  .active{
    color: #F3831F !important;
  }
  .guide_title ul>li:last-child:hover,.guide_title ul>li:last-child:focus{
    background-color:#f5943d!important;
    border-color:#f5943d!important;
  }
  .guide_title ul>li{
    color:#FFFFFF;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin-left:12px;
    cursor: pointer;
    width:84px;
    height:32px;
    line-height: 32px;
    text-align: center;
  }
  .guide_title ul>li:last-child{
    background-color:#F3831F!important;
    border-radius: 4px;
    color:#fff!important;
  }
  .bottom_guide ul>li:hover,.bottom_title:hover{
    text-decoration: underline!important;
  }
  .main_router{
    position: absolute;
    top:0;
  }
  .span_content{
    font-size: 14px;
    color: #666666;
  }
  .body_content{
    width: 745px;
    background: #F4F4F4;
    border-radius: 4px;
    margin: 17px 0 45px;
  }
  .body_content>div{
    padding:15px;
    color:#999999;
    display: flex;
    flex-direction:column;
    line-height:21px;
  }
  .guide_title li:hover{
    color:#F3831F
  }
  .guide_title li.is_active:hover{
    color:#fff
  }
  .main_router{
    width:100%;
    height:100%;
  }
  .menu{
    position: relative;
    width:25px;
    height:10px;
    z-index:5;
  }
  .menu1{
    position: relative;
    z-index:5;
    height:30px;
    width:50px;
  }
  .menu::after{
    position: absolute;
    bottom:0;
    right:0;
    width: 25px;
    height: 1px;
    background: #fff;
    content: '';
    animation: rotate1 0.2s ease;
  }
  .menu::before{
    position: absolute;
    top:0;
    right:0;
    width: 25px;
    height: 1px;
    background: #fff;
    content: '';
    animation: rotate 0.2s ease;
  }
  .menu1::after{
    position: absolute;
    top:50%;
    right:0px;
    width: 20px;
    height: 1px;
    background: #fff;
    content: '';
    transform-origin:50% 50%;
    transform:translateY(-50%) rotate(45deg);
    animation: rotate 0.2s ease;
  }
  .menu1::before{
    position: absolute;
    top:50%;
    right:0px;
    width: 20px;
    height: 1px;
    background: #fff;
    transform:translateY(-50%) rotate(-45deg);
    content: '';
    transform-origin:50% 50%;
    animation: rotate1 0.2s ease;
  }
  .menu_logo {
    height: 30px;
  }
  .menu_list{
    position: fixed;
    top:0;
    background-color:rgba(0,0,0,0.85);
    z-index:10;
    width:140px;
    border-right: 3px solid #F3831F;
    height:100%;
    animation: rotate2 0.2s ease;
  }
  .menu_list ul li{
    margin:0 20px 20px;
    text-align: center;
    color:#fff;
    border-bottom: 1px solid rgba(255,255,255,0.1);
  }
  .menu_list ul li:hover{
    cursor: pointer;
  }
  .menu_list ul li:nth-child(2){
    animation: rotate3 0.5s ease;
    transition-delay: 0.1s;
  }
  .menu_list ul li:nth-child(3){
    animation: rotate3 0.55s ease;
    transition-delay: 0.1s;
  }
  .menu_list ul li:nth-child(4){
    animation: rotate3 0.6s ease;
    transition-delay: 0.1s;
  }
  .menu_list ul li:nth-child(5){
    animation: rotate3 0.65s ease;
    transition-delay: 0.1s;
  }
  .menu_list ul li:nth-child(6){
    animation: rotate3 0.7s ease;
    transition-delay: 0.1s;
  }
  .menu_list ul li:nth-child(7){
    animation: rotate3 0.75s ease;
    transition-delay: 0.1s;
  }
  .menu_list ul li>span{
    display: block;
    color:#fff;
    margin-bottom: 20px;
  }
  .menu_list ul li:first-child{
    background-color: #000;
    border:0!important;
  }
  .menu_list ul li>img{
    height:30px;
    margin:10px 0;
  }
  .home_bottom1{
    display: none;
  }
  .top_header{
    position: fixed;
    width:65px;
    right:0;
    bottom:30%;
    z-index:7
  }
  .top_header>div{
     padding: 5px;
     height:64px;
     background-color: #F3831F;
    text-align: center;
    cursor: pointer;
   }
  .top_header>div>span{
    display: inline-block;
    font-size: 12px;
    color:#fff;
  }
  .top_header>div>img{
    width:35px;
  }
  .bar{
    width:50px;
    height:20px;
    background-color: #F3831F;
    position: absolute;
    left:0;
    top:0;
  }
  @keyframes rotate {
    from{
      opacity: 0;
      transform: rotate(45deg);
    }
    to{
      opacity: 1;
      transform: rotate(0deg);
    }
  }
  @keyframes rotate1 {
    from{
      opacity: 0;
      transform: rotate(-45deg);
    }
    to{
      opacity: 1;
      transform: rotate(0deg);
    }
  }
  @keyframes rotate2 {
    from{
      width:0;
      opacity: 0;
    }
    to{
      width:140px;
      opacity: 1;
    }
  }
  @keyframes rotate3 {
    from{
      position: relative;
      top:150px;
      opacity:0;
    }
    to{
      position: relative;
      top:0px;
      opacity: 1;
    }
  }
  .bar_menu{
    position: relative;
    display: none;
    height:50px;
  }
  .bar_menu>div{
    position: relative;
    padding:0 20px;
    height:100%;
    display: flex;
    justify-content: space-between;
    align-items:center;
  }
  .mack{
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    right:0;
    top:0;
    height:100%;
    width:100%;
    z-index:3
  }
  .bottom_erweima_ing{
    width:250px;
    position: fixed;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);
    z-index:8
  }
</style>



// WEBPACK FOOTER //
// src/App.vue